import { render, staticRenderFns } from "./SucceedTwo.vue?vue&type=template&id=30eb3fae&scoped=true"
import script from "./SucceedTwo.vue?vue&type=script&lang=js"
export * from "./SucceedTwo.vue?vue&type=script&lang=js"
import style0 from "./SucceedTwo.vue?vue&type=style&index=0&id=30eb3fae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30eb3fae",
  null
  
)

export default component.exports